interface GalleryCategory {
  id: number
  name: string
  slug: string
  media_count: number
}

interface CategoryFilterProps {
  categories: GalleryCategory[]
  activeCategory: string
  onCategoryChange: (slug: string) => void
}

function CategoryFilter({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) {
  // Only show filter if there are categories with media
  const categoriesWithMedia = categories.filter((cat) => cat.media_count > 0)

  if (categoriesWithMedia.length === 0) {
    return null
  }

  return (
    <div className="category-filter">
      <button
        className={activeCategory === 'all' ? 'active' : ''}
        onClick={() => onCategoryChange('all')}
      >
        Tous
      </button>
      {categoriesWithMedia.map((category) => (
        <button
          key={category.id}
          className={activeCategory === category.slug ? 'active' : ''}
          onClick={() => onCategoryChange(category.slug)}
        >
          {category.name}
        </button>
      ))}
    </div>
  )
}

export default CategoryFilter
